import React, {useEffect, useState, useMemo} from "react";
import styles from "./styles.module.scss";
import {
    Table,
    TextInput,
    SearchButton,
    LightTextButton,
    Icon,
    SwitchButton
} from "components";
import {useDispatch, useSelector} from "react-redux";
import {
    defaultPrivilegesAction,
    rolesAction,
    modulesAction,
    privilegesAction
} from "redux/actions";
import {internalSearch} from "helper";
import DefaultPrivilegePopup from "../popups/DefaultPrivilege";
import {MdEdit} from "react-icons/md";

const tableHeaders = [
    "ID",
    {title: "Role", sortBy: "role"},
    "Module",
    "Privilege",
    "Created At",
    "Created By",
    "Updated At",
    "Updated By",
    "Enabled",
    "Edit"
    // "Delete"
];

const initialState = {
    role: "",
    module: "",
    privilege: ""
};

const DefaultPrivilegePanel = () => {
    // Disptach redux action to get default privileges
    const dispatch = useDispatch();
    const {defaultPrivileges, roles, modules, privileges, userRole} =
        useSelector(state => ({
            ...state,
            userRole: state.userRole?.filter(role => role.module === "Users")
        }));

    const [search, setSearch] = useState(initialState);
    const [editableDetails, setEditableDetails] = useState();

    // Effects
    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read")) {
            dispatch(defaultPrivilegesAction.get());
            dispatch(rolesAction.get());
            dispatch(modulesAction.get());
            dispatch(privilegesAction.get());
        }
    }, [dispatch]);

    const rows = useMemo(() => {
        let filtered = defaultPrivileges;

        if (!filtered?.length) return [];

        const data = filtered;

        filtered = filtered?.map(obj => ({
            ...obj,
            role: roles?.find(item => item?.role_id == obj?.role)?.role_name,
            module: modules?.find(item => item?.module_id == obj?.module)
                ?.module_name,
            privilege: privileges?.find(item => item?.privilege_id == obj?.privilege)
                ?.name
        }));

        filtered = internalSearch(search, "role", filtered);
        filtered = internalSearch(search, "module", filtered);
        filtered = internalSearch(search, "privilege", filtered);

        filtered = filtered?.map(obj => ({
            default_role_p_id: obj?.default_role_p_id,
            role: obj?.role,
            module: obj?.module,
            privilege: obj?.privilege,
            created_at: `${new Date(obj?.created_at).toLocaleString()}`,
            created_by: obj?.created_by,
            updated_at: `${new Date(obj?.updated_at).toLocaleString()}`,
            updated_by: obj?.updated_by,
            enabled: (
                <SwitchButton
                    enabled={obj?.enabled}
                    onClick={
                        userRole?.find(item => item.privilege === "Enable")
                            ? () =>
                                dispatch(
                                    obj?.enabled
                                        ? defaultPrivilegesAction.inactive(obj?.default_role_p_id)
                                        : defaultPrivilegesAction.active(obj?.default_role_p_id)
                                )
                            : null
                    }
                />
            ),
            edit: (
                <Icon
                    ReactIcon={MdEdit}
                    name="MdEdit"
                    color="primary"
                    onClick={
                        userRole?.find(item => item.privilege === "Update")
                            ? () =>
                                setEditableDetails(
                                    data?.find(
                                        item => item?.default_role_p_id === obj?.default_role_p_id
                                    )
                                )
                            : null
                    }
                />
            )
            // delete: (
            //   <Icon
            //     color="danger"
            //     onClick={() =>
            //       dispatch(defaultPrivilegesAction.remove(obj?.default_role_p_id))
            //     }
            //   />
            // )
        }));

        return filtered;
    }, [defaultPrivileges, roles, modules, privileges, search]);

    const handleChange = setter => event =>
        setter(prev => ({...prev, [event.target.name]: event.target.value}));

    return (
        <div>
            <div className={styles.filter}>
                <TextInput
                    label="Role Name"
                    name="role"
                    value={search?.role}
                    onChange={handleChange(setSearch)}
                />

                <TextInput
                    label="Module Name"
                    name="module"
                    value={search?.module}
                    onChange={handleChange(setSearch)}
                />

                <TextInput
                    label="Privilege Name"
                    name="privilege"
                    value={search?.privilege}
                    onChange={handleChange(setSearch)}
                />
                <SearchButton/>
                <LightTextButton onClick={() => setSearch(initialState)}/>
            </div>
            <Table headers={tableHeaders} data={rows}/>

            {editableDetails && (
                <DefaultPrivilegePopup
                    data={editableDetails}
                    closeModal={() => setEditableDetails()}
                />
            )}
        </div>
    );
};

export default DefaultPrivilegePanel;
